import { gql } from "lib/apolloClient";
import { parentFragment } from "./FamilyProfileFragments";

export const editUserMutation = gql`
  mutation editUser(
    $id: ID!
    $firstName: String
    $middleName: String
    $lastName: String
    $preferredName: String
    $prefix: String
    $suffix: String
    $pronouns: String
    $email: String
    $profileImage: String
  ) {
    platform {
      updateUserV2(
        input: {
          id: $id
          firstName: $firstName
          middleName: $middleName
          lastName: $lastName
          preferredName: $preferredName
          prefix: $prefix
          suffix: $suffix
          pronouns: $pronouns
          email: $email
          profileImage: $profileImage
        }
      ) {
        warning
        isSuccess
        user {
          ...parentItem
        }
      }
    }
  }
  ${parentFragment.basicParentDetails}
`;

export const declineFamilyInvitationMutation = gql`
  mutation declineFamilyInvitation($input: DeclineInvitationInput!) {
    platform {
      declineFamilyInvitation(input: $input) {
        warning
        response
      }
    }
  }
`;

export const removeChildForFamilyMemberMutation = gql`
  mutation removeChildForFamilyMember($studentId: ID!, $parentId: ID) {
    platform {
      removeChildForFamilyMember(studentId: $studentId, parentId: $parentId)
    }
  }
`;
